<template>
  <div class="login">
    <div id="nav" class="header">
      <head-top></head-top>
    </div>
    <div class="main">
      <log-in></log-in>
    </div>
  </div>
</template>

<script>
import headTop from "./../../components/headTop";
import logIn from "./../../components/user/login";
export default {
  components: {
    headTop,
    logIn
  },
  data() {
    return {};
  },
  mounted(){
    var _this=this
  },

  methods: {}
};
</script>
<style lang="scss">
.login{
  .user-login{
    border-bottom: 1px solid #fff;
  }
}
</style>
<style lang='scss' scoped>
.login {
  background: url("./../../assets/img/pic_bg.png") no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  .main{
    height: calc(100vh - 350px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>